// extracted by mini-css-extract-plugin
module.exports = {"ClaimerLicensorsPeriodDiagram":"_2TDJNWtRdG_jfmK7Edxsr3"};